import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getLang from 'I18n/utils/getLang';
import { DescriptionList } from 'foundations-components/transitional/components/DescriptionList';
import { Link } from 'foundations-components/transitional/components/Link';
import { List } from 'foundations-components/transitional/components/List';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Fragment, useCallback } from 'react';
import { useDetailsPageContext } from '../context/DetailsPageContext';
import { getFormattedUrl, getHubSpotAcceptableUseUrl, getHubSpotPrivacyUrl, getHubSpotTermsOfServiceUrl } from '../utils/DetailsPageUrls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function LegalNotice({
  productType,
  homemade,
  langCode,
  trackInteraction
}) {
  switch (productType) {
    case 'AGENT':
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "detailsPage.infoCard.legal.agent.legalNotice"
      });
    default:
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: homemade ? 'detailsPage.infoCard.legal.app.homemadeDataEnrichmentNotice_jsx' : 'detailsPage.infoCard.legal.app.dataEnrichmentNotice_jsx',
        options: {
          aupLink: {
            href: getHubSpotAcceptableUseUrl(langCode),
            onClick: () => {
              trackInteraction('click acceptable use policy link');
            }
          },
          tosLink: {
            href: getHubSpotTermsOfServiceUrl(langCode),
            onClick: () => {
              trackInteraction('click customer terms of service link');
            }
          }
        },
        elements: {
          Link
        }
      });
  }
}
export function LegalTab({
  homemade,
  onTrackInteraction = () => {},
  privacyUrl,
  privacy2Url,
  privacy3Url,
  termsUrl
}) {
  const langCode = getLang();
  const {
    productType
  } = useDetailsPageContext();
  const trackInteraction = useCallback(action => onTrackInteraction(action, {
    section: 'data privacy'
  }), [onTrackInteraction]);
  const trackOtherPrivacyPolicyLinkClick = useCallback(() => trackInteraction('click other privacy policy link'), [trackInteraction]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(LegalNotice, {
        productType: productType,
        homemade: homemade,
        langCode: langCode,
        trackInteraction: trackInteraction
      })
    }), /*#__PURE__*/_jsxs(DescriptionList, {
      children: [homemade ? /*#__PURE__*/_jsx("dd", {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "detailsPage.infoCard.legal.privacyPolicyHomemade_jsx",
          options: {
            privacyPolicyLink: {
              href: getHubSpotPrivacyUrl(langCode),
              onClick: () => {
                trackInteraction('click product privacy policy link');
              }
            }
          },
          elements: {
            Link
          }
        })
      }) : /*#__PURE__*/_jsx("dd", {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "detailsPage.infoCard.legal.privacyPolicy_jsx",
          options: {
            privacyLinkProps: {
              href: getFormattedUrl(privacyUrl) || '',
              onClick: () => trackInteraction('click privacy policy link')
            },
            tosLinkProps: {
              href: getFormattedUrl(termsUrl) || '',
              onClick: () => trackInteraction('click terms link')
            }
          },
          elements: {
            Link
          }
        })
      }), (privacy2Url || privacy3Url) && /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx("dt", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "detailsPage.infoCard.legal.additionalPrivacyInformationLabel"
          })
        }), /*#__PURE__*/_jsx("dd", {
          children: /*#__PURE__*/_jsxs(List, {
            children: [privacy2Url && /*#__PURE__*/_jsx(Link, {
              href: getFormattedUrl(privacy2Url) || '',
              onClick: trackOtherPrivacyPolicyLinkClick,
              children: /*#__PURE__*/_jsx(TruncateString, {
                children: privacy2Url
              })
            }), privacy3Url && /*#__PURE__*/_jsx(Link, {
              href: getFormattedUrl(privacy3Url) || '',
              onClick: trackOtherPrivacyPolicyLinkClick,
              children: /*#__PURE__*/_jsx(TruncateString, {
                children: privacy3Url
              })
            })]
          })
        })]
      })]
    })]
  });
}